import { useInView } from 'react-intersection-observer'
import styles from './Reveal.module.scss'

// Static-CSS version (was makeStyles). Per-instance duration/delay are passed
// as CSS custom properties (--rv-dur / --rv-delay) via inline style, and the
// entrance direction via a data-dir attribute — see Reveal.module.scss. This
// keeps zero runtime CSS-in-JS while preserving the prefers-reduced-motion
// override and the exact timing/offset behaviour of the original.
const Reveal = ({
  children,
  delay = 0,
  duration = 0.7,
  direction = 'up',
  threshold = 0.15,
  className = '',
  component: Component = 'div',
  style,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold })

  return (
    <Component
      ref={ref}
      data-dir={direction}
      className={`${styles.reveal} ${inView ? styles.revealIn : ''} ${className}`}
      style={{
        '--rv-dur': `${duration}s`,
        '--rv-delay': `${delay}s`,
        ...style,
      }}
    >
      {children}
    </Component>
  )
}

export default Reveal
